module.exports = __webpack_public_path__ + "static/media/card-design-dinner-onme.c8976df6.png";